export default "/images/copy-application.png?7257c3ece1896b6b4ceb12caac7ddaed";